<section class="_layout-wrapper">
    <app-dashboard-topbar [sidebarOpen]="sidebarOpen()"></app-dashboard-topbar>
    <section class="_layout-main">
        <section class="_layout-sidebar" [class.expanded]="sidebarOpen()">
            <app-dashboard-menu [theme]="'dark'" [sidebarOpen]="sidebarOpen()" (sidebarToggleEvent)="toggleSidebar()"></app-dashboard-menu>&ndash;&gt;
        </section>
        <section class="_layout-content" [class._expanded]="sidebarOpen()">
            <router-outlet></router-outlet>
        </section>
    </section>
</section>
